// import components
import { GridColDef } from '@mui/x-data-grid-pro';
import DateCell from 'components/shared/Table/TableCell/DataGrid/DateCell';

// import hooks
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import {
  ExtendedTravelArrangementsData,
  TravelArrangementsData
} from '../types';

export const useGetColumns = () => {
  const { t } = useTranslation('common');

  const WIDTH = 110;

  return useMemo<GridColDef<ExtendedTravelArrangementsData>[]>(
    () => [
      {
        headerName: t('validFrom'),
        field: 'valid.from',
        type: 'date',
        renderCell: ({ row: { valid } }) => <DateCell value={valid?.from} />,
        width: WIDTH
      },
      {
        headerName: t('validTo'),
        field: 'valid.to',
        type: 'date',
        renderCell: ({ row: { valid } }) => <DateCell value={valid?.to} />,
        width: WIDTH
      },
      {
        headerName: t('employment'),
        field: 'waNr',
        type: 'string',
        valueGetter: (_, row: TravelArrangementsData) =>
          row.waNr === null || row.waNr === undefined
            ? t('allWorkAgreementsWithException')
            : row.waNr,
        width: WIDTH
      },
      {
        headerName: t('travelArrangements.compensationTypeName'),
        field: 'compensationTypeName',
        width: 240,
        type: 'string'
      },
      {
        headerName: t('travelArrangements.trvSetDescription'),
        field: 'trvSetDescription',
        type: 'string',
        width: WIDTH
      },
      {
        headerName: t('travelArrangements.countryCode'),
        field: 'countryCode',
        type: 'string',
        width: WIDTH
      },
      {
        headerName: t('postalCode'),
        field: 'postalCode',
        type: 'string',
        width: WIDTH
      },
      {
        headerName: t('travelArrangements.distanceInKm'),
        field: 'distanceKm',
        type: 'string',
        width: WIDTH
      },
      {
        headerName: t('travelArrangements.amount'),
        field: 'travelExpensesNominal',
        type: 'string',
        width: WIDTH
      },
      {
        headerName: t('travelArrangements.comments'),
        field: 'comment',
        type: 'string',
        flex: 1,
        width: WIDTH
      }
    ],
    []
  );
};
